import { MainPage } from "../../MainPage";
import { VentanaBase } from "../controlD3/AVentanaBase";
import { UIUtilViewAlumnoEdoCtaFacturacion } from "../utilView/AlumnoEdoCta/AlumnoEdoCtaFacturacionForm/FacturacionForm";

export class UIVentanaPlayground extends VentanaBase {
    constructor(container) {
        super(container)

        MainPage._StopWorker();

        // new FinanzaAgrupadorCargosModal() // Abre el modal para agrupar cargos
        UIUtilViewAlumnoEdoCtaFacturacion._OpenModal_GeneraCFDI(4, 421, null, []) // Abre el modal para generar CFDI
    }
}